import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Button } from 'reactstrap';
import { useIntl } from 'react-intl';

import UpgradePlanButton from '../../UpgradePlanButton';

const AdminRolesHeader = ({
  rolesVisible,
  rolesTotal,
  loading,
  history,
}) => {
  const intl = useIntl();

  return (
    <header className="page-header with-upgrade-button">
      <h3 className="page-title">
        {intl.formatMessage({ defaultMessage: 'Custom Roles' })}
      </h3>
      <UpgradePlanButton feature="custom-roles" />
      <div className="header-actions users-actions">
        <div className="items-displaying users-displaying">
          {(!loading && rolesTotal > 0) && (
            <span>
              {intl.formatMessage(
                { defaultMessage: '{rolesVisible} of {rolesTotal} Custom Roles' },
                { rolesVisible, rolesTotal },
              )}
            </span>
          )}
        </div>
        <div className="button-wrapper">
          <Button color="primary" onClick={() => { history.push('/admin/settings/roles/add'); }}>
            <i className="fas fa-plus" />
            <span>
              {intl.formatMessage({ defaultMessage: 'Custom Role' })}
            </span>
          </Button>
        </div>
      </div>
    </header>
  );
};

AdminRolesHeader.propTypes = {
  history: PropTypes.object.isRequired,
  rolesVisible: PropTypes.string.isRequired,
  rolesTotal: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default withRouter(AdminRolesHeader);
